import React from "react";
import './Admin.css'
import Navbar from "../Components/Navbar/Navbar";
import SlideBar from "./SlideBar/SlideBar";


export default function Admin() {

   return (
      <>
<SlideBar/>

      </>

   )
}